import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CheckCircle, XCircle, Award } from 'lucide-react';
import api from '../../utils/api';

const AcademyCertVerify = () => {
  const { certId } = useParams();
  const [state, setState] = useState({ loading: true });

  useEffect(() => {
    api.get(`/academy/certificate/verify/${certId}`)
      .then((r) => setState({ loading: false, ...r.data }))
      .catch(() => setState({ loading: false, valid: false }));
  }, [certId]);

  if (state.loading) return <div className="min-h-screen flex items-center justify-center text-white">Verifying…</div>;

  const valid = state.valid;
  const c = state.certificate || {};

  return (
    <div className="min-h-screen py-14 px-4 bg-gradient-to-b from-slate-950 via-fuchsia-950/30 to-slate-950 flex items-center justify-center" data-testid="cert-verify-page">
      <div className={`max-w-lg w-full rounded-2xl border-2 ${valid ? 'border-emerald-400 bg-emerald-500/10' : 'border-rose-400 bg-rose-500/10'} p-8 text-center`}>
        {valid ? (
          <>
            <CheckCircle className="w-20 h-20 text-emerald-400 mx-auto mb-4" />
            <div className="text-emerald-300 text-xs font-bold uppercase tracking-widest mb-2">Verified Certificate</div>
            <div className="text-white text-3xl font-black mb-4 flex items-center justify-center gap-2">
              <Award className="w-7 h-7 text-amber-400" /> {c.student_name}
            </div>
            <div className="text-slate-300">has completed the course</div>
            <div className="text-amber-300 text-xl font-bold mt-2 mb-6">&ldquo;{c.course_title}&rdquo;</div>
            <div className="grid grid-cols-3 gap-3 text-center text-xs">
              <div className="bg-slate-800/60 rounded-lg py-3">
                <div className="text-slate-400 uppercase font-bold">Modules</div>
                <div className="text-white text-xl font-bold">{c.modules_completed}</div>
              </div>
              <div className="bg-slate-800/60 rounded-lg py-3">
                <div className="text-slate-400 uppercase font-bold">AT Earned</div>
                <div className="text-amber-300 text-xl font-bold">{c.total_at_earned}</div>
              </div>
              <div className="bg-slate-800/60 rounded-lg py-3">
                <div className="text-slate-400 uppercase font-bold">Issued</div>
                <div className="text-white text-sm font-bold">{(c.issued_at || '').slice(0, 10)}</div>
              </div>
            </div>
            <div className="mt-6 text-slate-500 text-xs font-mono" data-testid="cert-id">Cert ID: {c.cert_id}</div>
            <div className="mt-4 text-emerald-300 text-sm">Issued by Anant Web Portal · Freedom Academy</div>
          </>
        ) : (
          <>
            <XCircle className="w-20 h-20 text-rose-400 mx-auto mb-4" />
            <div className="text-rose-300 text-lg font-bold">Certificate not found or invalid</div>
            <div className="text-slate-400 text-sm mt-2">Cert ID: {certId}</div>
          </>
        )}
      </div>
    </div>
  );
};

export default AcademyCertVerify;
